// extracted by mini-css-extract-plugin
export default {"card":"fZ-z","carouselContainer":"gZ-z","carouselContent":"hZ-z"};